'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListingDetails = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCollapsible = require('react-collapsible');

var _reactCollapsible2 = _interopRequireDefault(_reactCollapsible);

var _reactRedux = require('react-redux');

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _uniq2 = require('lodash/uniq');

var _uniq3 = _interopRequireDefault(_uniq2);

var _nuiIntl = require('@concur/nui-intl');

var _reactRouter = require('react-router');

var _Carousel = require('./Carousel');

var _Carousel2 = _interopRequireDefault(_Carousel);

var _LogoLinksAndDesc = require('./LogoLinksAndDesc');

var _LogoLinksAndDesc2 = _interopRequireDefault(_LogoLinksAndDesc);

var _termsModule = require('../terms/termsModule');

var _terms = require('../terms');

var _terms2 = _interopRequireDefault(_terms);

var _EnrollModal = require('./EnrollModal');

var _EnrollModal2 = _interopRequireDefault(_EnrollModal);

var _UnenrollModal = require('./UnenrollModal');

var _UnenrollModal2 = _interopRequireDefault(_UnenrollModal);

var _DisconnectModal = require('./DisconnectModal');

var _DisconnectModal2 = _interopRequireDefault(_DisconnectModal);

var _ConfirmationModal = require('./ConfirmationModal');

var _ConfirmationModal2 = _interopRequireDefault(_ConfirmationModal);

var _trackClick = require('../HOCs/trackClick');

var _utils = require('../utils');

var _offeringTypes = require('../config/offeringTypes');

var _offeringTypes2 = _interopRequireDefault(_offeringTypes);

var _regions = require('../config/regions');

var _regions2 = _interopRequireDefault(_regions);

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require('./style/listingDetails.css') : void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListingDetails = exports.ListingDetails = function (_React$Component) {
  _inherits(ListingDetails, _React$Component);

  function ListingDetails() {
    _classCallCheck(this, ListingDetails);

    var _this = _possibleConstructorReturn(this, (ListingDetails.__proto__ || Object.getPrototypeOf(ListingDetails)).call(this));

    _this.state = { detailsExpanded: false, regionIsDisplayed: false };
    _this._toggleDetails = _this._toggleDetails.bind(_this);
    _this._toggleRegionDisplay = _this._toggleRegionDisplay.bind(_this);
    _this.launchTandCinfoOnly = _this.launchTandCinfoOnly.bind(_this);
    return _this;
  }

  _createClass(ListingDetails, [{
    key: '_toggleDetails',
    value: function _toggleDetails() {
      // if this ever needs to be re-used or gets ugly, we can consider:
      // https://github.com/craigambrose/react-more/blob/master/lib/index.js
      this.setState({ detailsExpanded: !this.state.detailsExpanded });
    }
  }, {
    key: 'launchTandCinfoOnly',
    value: function launchTandCinfoOnly() {
      this.props.launchTaCModal({
        tAndCLinkClicked: true,
        ID: this.props.listing.ID,
        v1ListingId: this.props.listing.core.v1ID
      });
    }
  }, {
    key: 'renderDisabledWarning',
    value: function renderDisabledWarning() {
      var isDisabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var hasOfferings = arguments[1];
      var isAdminListing = arguments[2];

      if (isDisabled) {
        return _react2.default.createElement(_nuiIntl.FormattedMessage, {
          id: 'ListingDisabledByCompany',
          className: 'cnqr-alert cnqr-alert-warning disabled-warning'
        });
      }

      if (!hasOfferings && !isAdminListing) {
        return _react2.default.createElement(_nuiIntl.FormattedMessage, {
          id: 'ListingNotCompatibleWithOfferings',
          className: 'cnqr-alert cnqr-alert-warning disabled-warning'
        });
      }
      return null;
    }
  }, {
    key: 'renderOfferings',
    value: function renderOfferings() {
      var offerings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return _react2.default.createElement(
        'ul',
        null,
        offerings.map(function (offering) {
          return _react2.default.createElement(
            'li',
            { key: offering },
            _react2.default.createElement(
              'p',
              null,
              _offeringTypes2.default[offering]
            )
          );
        })
      );
    }
  }, {
    key: '_toggleRegionDisplay',
    value: function _toggleRegionDisplay() {
      this.setState({ regionIsDisplayed: !this.state.regionIsDisplayed });
    }
  }, {
    key: 'renderRegions',
    value: function renderRegions(regions) {
      var _this2 = this;

      var localizedRegionsAndCountries = void 0;
      if (this.props.localizedRegions && this.props.localizedCountries) {
        localizedRegionsAndCountries = Object.entries(regions).map(function (region) {
          var localizedRegionName = (0, _find3.default)(_this2.props.localizedRegions, function (localizedRegion) {
            return localizedRegion.code === _regions2.default[region[0]];
          });

          var localizedCountries = [];
          region[1].map(function (countryCode) {
            var localizedCountryName = (0, _find3.default)(_this2.props.localizedCountries, function (localizedCountry) {
              return localizedCountry.code === countryCode;
            });
            return localizedCountries.push(localizedCountryName.description);
          });

          return { region: localizedRegionName.description, countries: localizedCountries };
        });
      }

      var output = void 0;
      if (localizedRegionsAndCountries) {
        output = localizedRegionsAndCountries.filter(function (region) {
          return region.countries.length !== 0;
        }).map(function (i) {
          return _react2.default.createElement(
            'div',
            {
              onClick: _this2._toggleRegionDisplay,
              key: i.region
            },
            _react2.default.createElement(
              _reactCollapsible2.default,
              {
                key: i.region,
                trigger: _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'a',
                    { className: 'region-list-element', tabIndex: '0' },
                    i.region
                  ),
                  _react2.default.createElement('span', {
                    id: 'country-list',
                    className: (_this2.state.regionIsDisplayed ? 'region-opened' : 'region-closed') + ' icon-arrow-1-n icon-size-sm'
                  })
                ),
                classParentString: 'regions-collapse'
              },
              _react2.default.createElement(
                'ul',
                null,
                Object.values((0, _uniq3.default)(i.countries)).map(function (country) {
                  return _react2.default.createElement(
                    'li',
                    { key: country },
                    _react2.default.createElement(
                      'p',
                      null,
                      country
                    )
                  );
                })
              )
            )
          );
        });
      }
      return _react2.default.createElement(
        'ul',
        null,
        output
      );
    }
  }, {
    key: 'renderBackToAppCenter',
    value: function renderBackToAppCenter(ID, listingName) {
      var _this3 = this;

      return _react2.default.createElement(
        _trackClick.Tracked,
        {
          event: 'CLICK',
          additional: {
            context: 'LISTING_DETAILS',
            type: 'LINK',
            value: 'BACK_TO_APP_CENTER',
            v2_listing_id: ID,
            app_name: listingName,
            domain: window.location.hostname
          }
        },
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            {
              to: (0, _utils.getAppCenterPathName)(this.props.location.pathname),
              onClick: function onClick() {
                return document.title = _this3.context.getTitle(_utils.HOME);
              } },
            _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'BackToAppCenter' })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          listing = _props.listing,
          _props$offerings = _props.offerings,
          offerings = _props$offerings === undefined ? [] : _props$offerings;
      var ID = listing.ID,
          _listing$core = listing.core,
          listingDisabled = _listing$core.listingDisabled,
          regions = _listing$core.regions,
          listingName = _listing$core.listingName,
          oAuthWorkflowType = _listing$core.oAuthWorkflowType,
          clientOptInType = _listing$core.clientOptInType,
          v1ID = _listing$core.v1ID,
          _listing$core$offerin = _listing$core.offerings,
          listingOfferings = _listing$core$offerin === undefined ? [] : _listing$core$offerin;
      var userId = this.props.userPrefs.userId;


      var hasOfferings = !userId || userId && offerings.filter(function (offering) {
        return listingOfferings.indexOf(offering) !== -1;
      }).length > 0;

      var isAdminListing = clientOptInType === "ADMIN";

      var areRegionsPopulated = function areRegionsPopulated() {
        if (regions.asia.length > 0 || regions.emea.length > 0 || regions.latinAmerica.length > 0 || regions.northAmerica.length > 0) {
          return true;
        }
        return false;
      };

      return _react2.default.createElement(
        'div',
        { className: 'details-container' },
        _react2.default.createElement(_EnrollModal2.default, { listingId: ID, v1ListingId: v1ID }),
        _react2.default.createElement(_UnenrollModal2.default, { listingId: ID, v1ListingId: v1ID }),
        _react2.default.createElement(_DisconnectModal2.default, { listingId: ID, v1ListingId: v1ID }),
        _react2.default.createElement(_ConfirmationModal2.default, { listingId: ID, v1ListingId: v1ID }),
        _react2.default.createElement(
          'div',
          { className: 'row standard-font' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 back-link-row' },
                this.renderBackToAppCenter(ID, listingName),
                this.renderDisabledWarning(listingDisabled, hasOfferings, isAdminListing)
              )
            ),
            _react2.default.createElement(_LogoLinksAndDesc2.default, {
              listing: listing,
              toggleDetails: this._toggleDetails,
              detailsExpanded: this.state.detailsExpanded,
              listingDisabled: listingDisabled || !hasOfferings && !isAdminListing
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12 details-lower-row' },
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-12 margin-top-lg' },
                  this.props.listing.core.webScreenshots && this.props.listing.core.webScreenshots.length ? _react2.default.createElement(_Carousel2.default, { images: this.props.listing.core.webScreenshots }) : null
                )
              ),
              listing.core && listing.core.offerings.length > 0 && _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-6 margin-top-lg' },
                  _react2.default.createElement(
                    'h4',
                    { id: 'ac-offerings' },
                    _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'WorksWithTheseConcurOfferings' })
                  ),
                  listing.core && this.renderOfferings(listing.core.offerings)
                )
              ),
              listing.core && areRegionsPopulated() && _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-6 margin-top-lg', style: { marginBottom: !userId && '16px' } },
                  _react2.default.createElement(
                    'h4',
                    { id: 'ac-listing-regions' },
                    _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'RegionsAvailable' })
                  ),
                  listing.core && regions && this.renderRegions(regions)
                )
              ),
              userId && _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-6 margin-top-lg' },
                  _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(
                      'a',
                      {
                        href: '#',
                        className: 'ac-details-link',
                        id: 'ac-terms-link',
                        onClick: this.launchTandCinfoOnly
                      },
                      _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'TermsTitle' })
                    )
                  ),
                  (0, _utils.canUseDOM)() ? _react2.default.createElement(_terms2.default, {
                    listingId: ID,
                    v1ListingId: v1ID,
                    publisher: this.props.listing.localized.publisher,
                    partnerAppScopes: this.props.listing.core.partnerAppScopes,
                    flow: oAuthWorkflowType,
                    clientOptInType: this.props.listing.core.clientOptInType
                  }) : ''
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ListingDetails;
}(_react2.default.Component);

ListingDetails.propTypes = {
  listing: _propTypes2.default.shape({
    ID: _propTypes2.default.string,
    core: _propTypes2.default.object,
    images: _propTypes2.default.object,
    localized: _propTypes2.default.object,
    loyaltyNumber: _propTypes2.default.string,
    v1Data: _propTypes2.default.object
  }).isRequired,
  localizedRegions: _propTypes2.default.array,
  localizedCountries: _propTypes2.default.array,
  enroll: _propTypes2.default.func,
  toggleTaCModal: _propTypes2.default.func,
  launchTaCModal: _propTypes2.default.func,
  isTaCModalOpen: _propTypes2.default.bool,
  updateTermsStatus: _propTypes2.default.func,
  postTerms: _propTypes2.default.func,
  terms: _propTypes2.default.shape({
    appcenterStatus: _propTypes2.default.object,
    isTaCModalOpen: _propTypes2.default.bool,
    appcenterTerms: _propTypes2.default.string,
    ereceiptTerms: _propTypes2.default.string,
    ereceiptStatus: _propTypes2.default.object,
    sharedInfoStatus: _propTypes2.default.object
  }).isRequired,
  userPrefs: _propTypes2.default.shape({
    userId: _propTypes2.default.string
  }),
  location: _propTypes2.default.object
};

ListingDetails.contextTypes = {
  nuiIntl: _propTypes2.default.object,
  isPublic: _propTypes2.default.bool,
  getTitle: _propTypes2.default.func
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(null, {
  launchTaCModal: _termsModule.launchTaCModal,
  toggleTaCModal: _termsModule.toggleTaCModal,
  postTerms: _termsModule.postTerms,
  updateTermsStatus: _termsModule.updateTermsStatus
})(ListingDetails));


//////////////////
// WEBPACK FOOTER
// ./lib/listing/ListingDetails.js
// module id = 576
// module chunks = 0